import ActivePrograms from './ActivePrograms.vue';

const components = [
  ActivePrograms,
];

export default components;



// WEBPACK FOOTER //
// ./src/components/active-programs/index.js